/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WriteOperationType = {
    Update: 'UPDATE',
    Delete: 'DELETE'
} as const;
export type WriteOperationType = typeof WriteOperationType[keyof typeof WriteOperationType];


export function instanceOfWriteOperationType(value: any): boolean {
    for (const key in WriteOperationType) {
        if (Object.prototype.hasOwnProperty.call(WriteOperationType, key)) {
            // @ts-ignore
            if (WriteOperationType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WriteOperationTypeFromJSON(json: any): WriteOperationType {
    return WriteOperationTypeFromJSONTyped(json, false);
}

export function WriteOperationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOperationType {
    return json as WriteOperationType;
}

export function WriteOperationTypeToJSON(value?: WriteOperationType | null): any {
    return value as any;
}

